import GradRate from './GradRate.component';

export default GradRate;
